"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Debounce is a function that will not execute the input function UNTILL
 * it has NOT been evoked for the {wait} milliseconds in duration. Thus essentially voided the excisting timer.
 * For the difference between debounce and throttled see:
 * https://codeburst.io/throttling-and-debouncing-in-javascript-646d076d0a44
 * @param  {any} func execution function
 * @param  {number} wait number in milliseconds of delay untill
 * @param  {boolean} immediate input function evokation can be done on head or tail of execution calls.
 */
var debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var later = function () {
            timeout = null;
            if (!immediate) {
                func();
            }
        };
        var callNow = immediate && !timeout;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func();
        }
    };
};
exports.default = debounce;
